<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
      <!-- <img src="~@/assets/index_logo.png" height="56px" alt=""> -->
      <h1 class="header-title" v-if="showTitle">{{VUE_APP_PLATFORM_NAME}}</h1>
    </router-link>
  </div>
</template>

<script>
  import { mixin } from '@/utils/mixin.js'

  export default {
    name: 'Logo',
    mixins: [mixin],
    props: {
      title: {
        type: String,
        default: 'Server-Boot',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    }
  }
</script>
<style lang="less" scoped>
  /*缩小首页布 局顶部的高度*/
  @height: 59px;
  .header-title{
    color: #fff;
    letter-spacing: 3px;
    font-family: 黑体;
    font-size: 26px;
  }

  .sider {
    box-shadow: none !important;
    .logo {
      height: @height !important;
      line-height: @height !important;
      box-shadow: none !important;
      transition: background 300ms;
      h1 {
        color: white;
      }
      a {
        color: white;
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    &.light .logo {
      background-color: @primary-color;
    }
  }
</style>